import { useDispatch, useSelector } from "react-redux";

import { desktopVmOptions } from "./constants";
import { addNotification } from "../../../store/actions/notifierActions";

// Checks shared by every "Submit to Sandbox" button before the SubmitPopup opens.
const useSandboxSubmitGuard = () => {
  const dispatch = useDispatch();
  const licenceCheck = useSelector((state) => state?.users.licenceCheck);
  const vms = useSelector((state) => state.dashboard.vms);

  const availableVmOptions = desktopVmOptions.filter((vmOption) => vms.includes(vmOption.id));

  const canOpenSubmitPopup = () => {
    if (!availableVmOptions.length) {
      dispatch(addNotification({ message: "No vm available.", options: { variant: "error" } }));
      return false;
    }
    if (!licenceCheck?.key) {
      dispatch(
        addNotification({
          message: "Your license is not active, please update your license key.",
          options: { variant: "error" },
        }),
      );
      return false;
    }
    return true;
  };

  return { hasLicence: !!licenceCheck?.key, availableVmOptions, canOpenSubmitPopup };
};

export default useSandboxSubmitGuard;
